import ManageAppAccess from './components/ManageAppAccess';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { isUnbound } from 'owa-linkedin';
import { isFeatureEnabled } from 'owa-feature-flags';

const AppsOption: Option = {
    key: 'appAccess',
    titleStringKey: 'optionTitle_app_access',
    searchTermsStringKey: 'optionTitle_app_access',
    fullOptionFormSettings: {
        render: () => <ManageAppAccess />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: () => !isFeatureEnabled('auth-linkedInOption') || isUnbound(),
};

export default AppsOption;
